import HttpBase from './http.base';
import AppConstants from '../constants.js';

const CONTROLLER_ROUTE = 'api/die-type';

class HttpDieType extends HttpBase {

  getDieTypes = (wcmId?: string): Promise<any> => {
    const lUrl =
      wcmId && wcmId.trim().length > 0
        ? `${AppConstants.baseURL}/${CONTROLLER_ROUTE}?wcmId=${encodeURIComponent(wcmId)}`
        : `${AppConstants.baseURL}/${CONTROLLER_ROUTE}`;

    return this.GET(lUrl);
  };

  postDieType = (data: any, wcmId?: string): Promise<any> => {
    const lUrl =
      wcmId && wcmId.trim().length > 0
        ? `${AppConstants.baseURL}/${CONTROLLER_ROUTE}?wcmId=${encodeURIComponent(wcmId)}`
        : `${AppConstants.baseURL}/${CONTROLLER_ROUTE}`;

    return this.POST(lUrl, data);
  };

  putDieType = (data: any, id: string, wcmId?: string): Promise<any> => {
    const lUrl =
      wcmId && wcmId.trim().length > 0
        ? `${AppConstants.baseURL}/${CONTROLLER_ROUTE}/${id}?wcmId=${encodeURIComponent(wcmId)}`
        : `${AppConstants.baseURL}/${CONTROLLER_ROUTE}/${id}`;

    return this.PUT(lUrl, data);
  };

  deleteDieType = (id: string, checkUsage: boolean, wcmId?: string): Promise<any> => {
    let lUrl = `${AppConstants.baseURL}/${CONTROLLER_ROUTE}/${id}?checkUsage=${checkUsage}`;

    if (wcmId && wcmId.trim().length > 0) {
      lUrl += `&wcmId=${encodeURIComponent(wcmId)}`;
    }

    return this.DELETE(lUrl);
  };
}

const httpDieType = new HttpDieType();
export { httpDieType };
